import {
  BirthControlMethodBreakpointOption,
  ConceiveTimingBreakpointOption,
  CycleChangesBreakpointOption,
  EligibleAppleWatchBreakpointOption,
  FeelingStressedBreakpointOption,
  GoalBreakpointOption,
  HormonalBirthControlHowLongBreakpointOption,
  HormonalBirthControlUsageBreakpointOption,
  MedicalConditionsBreakpointOption,
  NightSleepBreakpointOption,
  QuizDataInput,
  QuizEngine,
  QuizEngineConfig,
  QuizFlow,
  SideEffectsBreakpointOption,
  SleepWithTrackerOption,
  TrueOrFalseOption,
  WearWatchToBedOption,
  WhatToTrackWithDeviceOption,
  WhichWearableBreakpointOption,
} from '@naturalcycles/shared'
import { QuizSignatureObject } from '@src/app/core/services/quiz/quiz.service'
import { AnyPage, Page } from '@src/app/shared/typings/enum/pages'
import { Breakpoint, Sections } from '@src/app/shared/typings/enum/quiz'

export type BreakpointOption =
  | GoalBreakpointOption
  | BirthControlMethodBreakpointOption
  | SideEffectsBreakpointOption
  | ConceiveTimingBreakpointOption
  | HormonalBirthControlUsageBreakpointOption
  | HormonalBirthControlHowLongBreakpointOption
  | MedicalConditionsBreakpointOption
  | CycleChangesBreakpointOption
  | WhichWearableBreakpointOption
  | SleepWithTrackerOption
  | EligibleAppleWatchBreakpointOption
  | NightSleepBreakpointOption
  | FeelingStressedBreakpointOption
  | TrueOrFalseOption
  | WhatToTrackWithDeviceOption
  | WearWatchToBedOption

export type SignupQuizFlow = QuizFlow<Page>

export interface QuizState {
  flow: SignupQuizFlow
  data:
    | (QuizDataInput & {
        // ab348
        periodTrackerUsage?: TrueOrFalseOption
      })
    | null
  sections: Sections | null
  /**
   * The quiz signature is an object that identifies an instance of a quiz engine.
   * It contains all variables (and values) that are taken into consideration when initializing the quiz engine.
   */
  signature: QuizSignatureObject | null
  /**
   * We redirect to entry when user clicks back from the first page of the quiz.
   */
  entry: AnyPage[] | null
  /**
   * We redirect to exit when user navigates forward from the last page of the quiz.
   */
  exit: AnyPage[] | null
}

export interface WSQuizEngineConfig
  extends QuizEngineConfig<Breakpoint, BreakpointOption, Page, QuizDataInput> {}

export class WSQuizEngine extends QuizEngine<Breakpoint, BreakpointOption, Page, QuizDataInput> {}

export interface BirthControlMethodEfficacy {
  typicalUse: string
  perfectUse: string
}

export interface BirthControlMethod {
  nameKey: string
  imgDark: string
  imgLight?: string
  typicalUse?: string
  perfectUse?: string
}

interface BaseQuizSelectOption {
  key: number
  img?: string
  imgPosition?: 'top' | 'right'
  imgType?: 'illustration' | 'icon'
}

export interface TranslatableQuizSelectOption extends BaseQuizSelectOption {
  textKey: string
  expandedDescriptionKey?: string
}

export interface SingleLanguageQuizSelectOption extends BaseQuizSelectOption {
  text: string
  expandedDescription?: string
}

export type QuizSelectOption = TranslatableQuizSelectOption | SingleLanguageQuizSelectOption

/*
 * Info pages
 */

export interface InfoPageContent {
  imageUrl?: string
  titleKey?: string
  subtitleKey?: string
  buttonKey?: string
}

export interface BirthControlMethodInfoPageContent extends InfoPageContent {
  birthControlMethod?: BirthControlMethod
}

/**
 * Interfaces used in tests.
 */
export type FlowDefinition = Partial<Record<Breakpoint, BreakpointOption | BreakpointOption[]>>
